(function () {
    'use strict';

    angular
        .module('core.services')
        .service('NotifyHelper', NotifyHelper)

    /** @ngInject */
    function NotifyHelper(ngNotify) {
        const NotifyHelper = {
            success: success,
            warning: warning,
            error: error
        };

        ngNotify.config({
            theme: 'pure',
            position: 'top',
            duration: 5000,
            html: false
        });

        return NotifyHelper

        function success(message = 'Registro salvo com sucesso') {
            ngNotify.set(message, 'success');
        }

        function error(message = 'Ops, Ocorreu algum erro ao executar essa ação') {
            ngNotify.set(message, 'error');
        }

        function warning(message = 'Ops') {
            ngNotify.set(message, 'warning');
        }
    }
}());